<style lang="less" scoped>
.imgList {
    width: 75px;
    height: 75px;
    border: solid #888 1px;
    float: left;
    margin-top: 10px;
    margin-right: 10px;
    cursor:move;
    transition: 0.3s;
    background-size: cover;
    background-position: center;
    position: relative;
    &:hover {
        box-shadow: 0 0 5px #333;
    }
}
.delImg {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #E50000;
    cursor: pointer;
    right: -7px;
    top: 0px;
    display: flex;
    transition: 0.3s;
    &:hover {
        transform: rotate(180deg);
    }
    >div {
        width: 70%;
        height: 3px;
        margin: auto;
        background: #FFF;
    }
    
}
.formUl {
    >li {
        list-style: none;
        margin-bottom: 5px;
        >div {
            padding-left: 10px;
        }
    }
}
.grid6 {
    display: flex;
    text-align:center;
    >div {
        flex: 2;
        padding: 0 5px;
    }
    >div:nth-of-type(5) {
        flex: 3;
    }
}
.proTh {
    padding: 8px 0;
}

.delComm {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #E50000;
    margin-left: 30px;
    position: relative;
    &::after {
        display: block;
        content: "";
        width: 60%;
        height: 4px;
        background: #FFF;
        position: absolute;
        left: 50%;
        top:40%;
        transform: translateX(-50%);
    }
    cursor: pointer;
    transition: 0.3s;
    &:hover {
        transform:  rotate(180deg);
    }
}
.errMsg {
    border: solid #E50000 1px;
    border-radius: 5px;
}
.mt5 {
    margin-top: 7px;
}
.delIcon {
    position: absolute;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #E50000;
    cursor: pointer;
    right: -7px;
    top: 3px;
    display: flex;
    transition: 0.3s;
    &:hover {
        transform: rotate(180deg);
    }
    >div {
        width: 60%;
        height: 3px;
        margin: auto;
        background: #FFF;
    }
}
</style>

<template>
    <div>
        <h2 class="pageTitle">供應商訂單列表</h2>

        <!-- 搜索Box -->
        <div class="sb searchBoxWrap">
            <div class="al">
                <Input type="text" v-model="keyword" clearable @on-clear="search" @on-keydown.enter="search" /> 
                <Button type="primary" class="searchBtn" @click="search">搜索</Button>
            </div>
            <div>
                <Button type="info" @click="showAdd=true">+ 創建新供應商訂單</Button>
            </div>
        </div>

        <div class="tableWrap">
            <Table :columns="columns" :data="list" border @on-row-click="showAnOrder" :loading="tableLoad">
                <template slot="action" slot-scope="{row}">
                    <div class="ju">
                        <Button type="warning" size='small' style="margin-right: 10px;" @click.stop.prevent="edit(row)">編輯</Button>
                        <Button type="error" size='small' @click.stop.prevent="del(row)">刪除</Button>
                    </div>
                </template>
                <template slot="amount" slot-scope="{row}">
                    <span>${{format( row.amount.toFixed(2) )}}</span>
                </template>
            </Table>
        </div>

        <div class="PageWrap">
            <Page :current="page" :page-size="offset" :total="total" @on-change="changePage"></Page>
        </div>

        <!-- 創建 -->
        <Modal v-model="showAdd" :width="1000">
            <div slot="header" class="ModalHeader">
                <img src="@/assets/img/logo.png" width="180" alt="">
            </div>

            <div style="padding: 0 20px;">
                <Form :model="addForm" ref="addForm" :rules="rules" :label-width="120">
                    <div class="flex">
                        <!-- 左 -->
                        <div style="flex:4">
                            <FormItem label="供應商名稱:" prop="supplier_name">
                                <Input style="width: 80%;" v-model="addForm.supplier_name" />
                            </FormItem>
                            <FormItem label="訂單編號:" prop="order_code">
                                <Input style="width: 80%;" v-model="addForm.order_code" />
                            </FormItem>
                            <FormItem label="創建日期:" prop="create_time">
                                <DatePicker type="date" :value='addForm.create_time' format="yyyy-MM-dd" @on-change="changeDate( $event,'addForm','create_time')" style="width: 80%;" />
                            </FormItem>
                        </div>
                        <!-- 中 -->
                        <div style="flex:4">
                            <FormItem label="訂單跟進同事:" prop="principal">
                                <Input type="text" v-model="addForm.principal" style="width: 80%;" />
                            </FormItem>
                            <FormItem label="狀態:" prop="status">
                                <Select v-model="addForm.status"  style="width: 80%;">
                                    <Option value="1">處理中</Option>
                                    <Option value="2">已付款</Option>
                                </Select>
                            </FormItem>

                            <FormItem label="備註:">
                                <textarea v-model="addForm.remark" style="width: 80%;padding:5px 10px;"></textarea>
                            </FormItem>
                        </div>
                        <!-- 右 -->
                        <div style="flex:2"></div>
                    </div>
                </Form>
                <div>
                    <div class="customTable">
                        <div class="grid6 proTh bold">
                            <div>產品名稱</div>
                            <div>數量</div>
                            <div>單價</div>
                            <div>產品編號</div>
                            <div>備註</div>
                            <div>小計</div>
                        </div>
                        <Form v-for="(item,i) in addForm.order_detail" :key="i" :ref="'row'+i" :modal="item" :rules="rules">
                            <div class="grid6"> 
                                <div>
                                    <FormItem prop="name">
                                        <Input v-model="item.name" :class="[{ errMsg: (!item.name)&&(validate1) }]" />
                                    </FormItem>
                                </div>
                                <div>
                                    <FormItem prop="count">
                                        <Input v-model="item.count" :class="[{ errMsg: (!item.count)&&(validate1) }]" type="number" />
                                    </FormItem>
                                </div>
                                <div>
                                    <FormItem prop="price">
                                        <Input v-model="item.price" :class="[{ errMsg: (!item.price)&&(validate1) }]" type="number" />
                                    </FormItem>
                                </div>
                                <div>
                                    <FormItem prop="sku">
                                        <Input v-model="item.sku" :class="[{ errMsg: (!item.sku)&&(validate1) }]" />
                                    </FormItem>
                                </div>
                                <div>
                                    <FormItem prop="remark">
                                        <Input v-model="item.remark" />
                                    </FormItem>
                                </div>
                                <div class="mt5 relative">
                                    <span>${{ format(item.price * item.count) }}</span>
                                    <div class="delImg" @click="delComm('addForm',i)"><div></div></div>
                                </div>
                            </div>
                        </Form>
                        <div class="ju">
                            <Button type="primary" size="small" @click="addPro('addForm')">+ 增加產品</Button>
                        </div>
                        
                    </div>

                    <div class="flex-end al" style="transform: translateY(20px)">
                        總價: 
                        <div class="al ju" style="width: 17.5%;">
                            
                            <span style="margin: 0px 4.5% 0 0"> ${{format(total1)}}</span>
                        </div>
                    </div>
                </div>
                <br>
            </div>

            <div slot="footer" class="flex-end ModalBtn">
                <Button type="error" size="small" @click="showAdd=false"> 取消 </Button>
                <Button type="info" size="small" @click="okAdd" :loading="load">+ 創建</Button>
            </div>
        </Modal>

        <!-- 詳情 -->
        <Modal v-model="showDetail" :width="800">
            <div slot="header" class="ModalHeader">
                <img src="@/assets/img/logo.png" width="180" alt="">
            </div>

            <div>
                <div class="flex">
                    <!-- 左 -->
                    <div style="flex:3.3">
                        <ul class="formUl">
                            <li class="al">
                                <span>供應商名稱:</span>
                                <div>
                                    <span>{{detail.supplier_name}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>訂單編號:</span>
                                <div>
                                    <span>{{detail.order_code}}</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>創建日期:</span>
                                <div>
                                    <span>{{detail.createAt}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- 中 -->
                    <div style="flex:3.3">
                        <ul class="formUl">
                            <li class="al">
                                <span>狀態:</span>
                                <div>
                                    <span v-if="detail.status==1" style="color: #6482AF;">處理中</span>
                                    <span v-if="detail.status==2" style="color: green;">已付款</span>
                                </div>
                            </li>
                            <li class="al">
                                <span>訂單跟進同事:</span>
                                <div>
                                    <span>{{detail.principal}}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <!-- 右 -->
                    <div style="flex:3.3">
                        <div class="flex-end">
                            <Button type="info" @click="exportCsv">下載</Button>
                        </div>
                    </div>
                </div>
                <div>
                    <myTable :columns="columns2" :list="detail.order_detail" :maxHeight="300" :searchable="false" ref="myTable">
                        <template slot="calc" slot-scope="{row}">
                            ${{format( (row.count * row.price).toFixed(2) )}}
                        </template>
                    </myTable>
  
                    <div class="flex-end al" style="transform: translateY(20px)">
                        總價: 
                        <div class="al ju" style="width: 17.5%;">
                            
                            <span style="margin: 0px 4.5% 0 0"> ${{format( detail.amount ? detail.amount.toFixed(2) : 0 )}}</span>
                        </div>
                            
                    </div>
                </div>
                
            </div>

            <div slot="footer"> </div>
        </Modal>

        <!-- 编辑 -->
        <Modal v-model="showEdit" :width="1000">
            <div slot="header" class="ModalHeader">
                <img src="@/assets/img/logo.png" width="180" alt="">
            </div>

            <div style="padding: 0 20px;">
                <Form :model="editForm" ref="editForm" :rules="rules" :label-width="120">
                    <div class="flex">
                        <!-- 左 -->
                        <div style="flex:4">
                            <FormItem label="供應商名稱:" prop="supplier_name">
                                <Input style="width: 80%;" v-model="editForm.supplier_name" />
                            </FormItem>
                            <FormItem label="訂單編號:" prop="order_code">
                                <Input style="width: 80%;" v-model="editForm.order_code" />
                            </FormItem>
                            <FormItem label="創建日期:" prop="create_time">
                                <DatePicker type="date" :value='editForm.createAt' format="yyyy-MM-dd" @on-change="changeDate( $event,'editForm','createAt')" style="width: 80%;" />
                            </FormItem>
                        </div>
                        <!-- 中 -->
                        <div style="flex:4">
                            <FormItem label="訂單跟進同事:" prop="principal">
                                <Input type="text" v-model="editForm.principal" style="width: 80%;" />
                            </FormItem>
                            <FormItem label="狀態:" prop="status">
                                <Select v-model="editForm.status"  style="width: 80%;">
                                    <Option value="1">處理中</Option>
                                    <Option value="2">已付款</Option>
                                </Select>
                            </FormItem>

                            <FormItem label="備註:">
                                <textarea v-model="editForm.remark" style="width: 80%;padding:5px 10px;"></textarea>
                            </FormItem>
                        </div>
                        <!-- 右 -->
                        <div style="flex:2"></div>
                    </div>
                </Form>
                <div>
                    <div class="customTable">
                        <div class="grid6 proTh bold">
                            <div>產品名稱</div>
                            <div>數量</div>
                            <div>單價</div>
                            <div>產品編號</div>
                            <div>備註</div>
                            <div>小計</div>
                        </div>
                        <Form v-for="(item,i) in editForm.order_detail" :key="i" :ref="'row'+i" :modal="item" :rules="rules">
                            <div class="grid6"> 
                                <div>
                                    <FormItem prop="name">
                                        <Input v-model="item.name" :class="[{ errMsg: (!item.name)&&(validate2) }]" />
                                    </FormItem>
                                </div>
                                <div>
                                    <FormItem prop="count">
                                        <Input v-model="item.count" :class="[{ errMsg: (!item.count)&&(validate2) }]" type="number" />
                                    </FormItem>
                                </div>
                                <div>
                                    <FormItem prop="price">
                                        <Input v-model="item.price" :class="[{ errMsg: (!item.price)&&(validate2) }]" type="number" />
                                    </FormItem>
                                </div>
                                <div>
                                    <FormItem prop="sku">
                                        <Input v-model="item.sku" :class="[{ errMsg: (!item.sku)&&(validate2) }]" />
                                    </FormItem>
                                </div>
                                <div>
                                    <FormItem prop="remark">
                                        <Input v-model="item.remark" />
                                    </FormItem>
                                </div>
                                <div class="mt5 relative">
                                    <span>${{ format(item.price * item.count) }}</span>
                                    <div class="delImg" @click="delComm('editForm',i)"><div></div></div>
                                </div>
                            </div>
                        </Form>
                        <div class="ju">
                            <Button type="primary" size="small" @click="addPro('editForm')">+ 增加產品</Button>
                        </div>
                        
                    </div>

                    <div class="flex-end al" style="transform: translateY(20px)">
                        總價: 
                        <div class="al ju" style="width: 17.5%;">
                            
                            <span style="margin: 0px 4.5% 0 0"> ${{format(total2)}}</span>
                        </div>
                    </div>
                </div>
                <br>
            </div>

            <div slot="footer" class="flex-end ModalBtn">
                <Button type="error" size="small" @click="showEdit=false"> 取消 </Button>
                <Button type="info" size="small" @click="okEdit" :loading="load">编辑</Button>
            </div>
        </Modal>


    </div>
</template>

<script>
export default {
    data () {
        return {
            columns: [
                { title: "編號", key: "id", sortable: true, align:"center", width: 100 },
                { title: "訂單編號", key: "order_code", sortable: true, align:"center" },
                { title: "總金額", key: "amount", sortable: true, align:"center", slot: "amount" },
                { title: "供應商", key: "supplier_name", sortable: true, align:"center" },
                { title: "創建日期", key: "createAt", sortable: true, align:"center" },
                { title: "操作", slot: "action", align:"center" },
            ],
            list: [],
            keyword: "",
            page: 1,
            total: 0,
            showAdd: false,
            showEdit: false,
            showDetail: false,
            columns2: [       // 訂單詳情
                { title: "產品名稱", key:"name" },
                { title: "產品編號", key:"sku" },
                { title: "數量", key:"count" },
                { title: "單價", key:"price" },
                { title: "備註", key:"remark" },
                { title: "小計", key:"calc", slot: "calc" },
            ],
            addForm: {
                supplier_name: "", order_code: "", status: "1", principal: "", create_time: "", remark: "",
                order_detail: [
                    { name: "", sku: "", count: "1", price: "", remark: "" },
                ]
            },
            editForm: {
                supplier_name: "", order_code: "", status: "1", principal: "", create_time: "", remark: "",
                order_detail: []
            },
            rules: {
                supplier_name: [ { required: "true", message: "請輸入供應商名稱", trigger: "blur" } ],
                order_code: [ { required: "true", message: "請輸入產品名稱", trigger: "blur" } ],
                principal: [ { required: "true", message: "請輸入訂單跟進同事", trigger: "blur" } ],
                create_time: [ { required: "true", message: "請選擇創建日期", trigger: "blur" } ],
            },
            load: false,
            tableLoad: false,
            detail: {
                order_detail: []
            },
            validate1: false,
            validate2: false,
        }
    },

    computed: {
        offset () { return this.$store.state.offset },
        role () { return this.$store.state.role },
        total1 () {
            let num = 0
            if (this.addForm.order_detail) {
                this.addForm.order_detail.forEach(item => {
                    num += (item.price * item.count)
                })
            }
            return num.toFixed(2) * 1
        },
        total2 () {
            let num = 0
            if (this.editForm.order_detail) {
                this.editForm.order_detail.forEach(item => {
                    num += (item.price * item.count)
                })
            }
            return num.toFixed(2) * 1
        }
    },
    created () {
        if (this.role == 2) {
            this.columns.pop()
        }
        this.initaddFormData()
        this.showTable()
    },
    methods:{
        changeDate (e, key,prop) {
            this[key][prop] = e
        },
        //刪除產品
        delComm (key, i) {
            this[key].order_detail.splice(i,1)
            if (this[key].order_detail.length===0) {
                this.addPro(key)
            }
        },
        //增加產品
        addPro (key) {
            this[key].order_detail.push( { name: "", sku: "", count: "1", price: "", remark: "" } )
        },
        format (n) {
            n = Number(n)
            var str = n.toString();
            str = str.replace(/[A-z]+/g, "")
            var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g
            let num = str.replace(reg,"$1,");
            return num
        },
        enterInfo (e,key,i, attr) {
            this[key].order_detail[i][attr] = e.data
        },
        search () {
            this.page = 1
            this.showTable()
        },
        showTable () {
            this.tableLoad = true
            this.$axios({
                url: "admin/supplierOrder",
                params: {
                    page: this.page,
                    offset: this.offset,
                    search: this.keyword
                }
            }).then(res => {
                console.log(res)
                this.tableLoad = false
                if (res.data.data) {
                    this.list = res.data.data
                    this.total = res.data.count
                    if (res.data.data.length == 0 && this.page > 1) {
                        this.page--
                        this.showTable()
                    }
                } else {
                    this.list = []
                    this.total = 0
                }
            }).catch(e => {
                console.log(e)
                this.tableLoad = false
                this.$Message.error("網絡錯誤, 請稍後再試")
            })
        },
        exportCsv () {
            window.location.href = this.$axios.defaults.baseURL + "admin/download_pdf?uuid=" + this.detail.uuid + "&action=supplier"
        },
        //顯示一個訂單詳情
        showAnOrder (item) {
            this.showDetail = true
            this.detail = item
        },
        changePage (e) {
            this.page = e
            this.showTable()
        },
        okAdd () {
            let that =this
            that.validate1 = true
            let boo = that.addForm.order_detail.every(item => {
                return (item.name)&&(item.count*1)&&item.price&&item.sku
            })
            // console.log(boo)
            this.$refs.addForm.validate(flag => {
                if (flag && boo) {
                    that.load = true
                    that.$axios({
                        url: "admin/supplierOrder",
                        method:"POST",
                        data: {
                            order_code: that.addForm.order_code,
                            supplier_name: that.addForm.supplier_name,
                            status: that.addForm.status * 1,
                            num: 1,
                            sku: "default",
                            amount: that.total1,
                            principal: that.addForm.principal,
                            create_time: that.addForm.create_time,
                            remark: that.addForm.remark,
                            order_detail: that.addForm.order_detail,
                        }
                    }).then(res => {
                            that.load = false
                            if (res.data.code == 200) {
                                that.$Message.success("創建成功")
                                that.showTable()
                                that.addForm = {
                                    supplier_name: "", order_code: "", status: "1", principal: "", create_time: "", remark: "",
                                    order_detail: [
                                        { name: "", sku: "", count: "1", price: "", remark: "" },
                                    ]
                                }
                                that.valifate1 = false
                                that.showAdd = false
                            } else {
                                that.$Message.warning(res.data.data.msg)
                            }
                        }).catch(e => {
                            console.log(e)  
                            that.load = false
                            that.$Message.error("網絡錯誤, 請稍後再試")
                        })
                }
                
            })
        },
        okEdit () {
            let that =this
            that.validate2 = true
            let boo = that.editForm.order_detail.every(item => {
                return (item.name)&&(item.count*1)&&item.price&&item.sku
            })
            this.$refs.editForm.validate(flag => {
                if (flag && boo) {
                    that.load = true
                    that.$axios({
                        url: "admin/supplierOrder",
                        method:"PUT",
                        data: {
                            uuid:that.editForm.uuid,
                            order_code: that.editForm.order_code,
                            supplier_name: that.editForm.supplier_name,
                            status: that.editForm.status * 1,
                            num: 1,
                            sku: "default",
                            amount: that.total2,
                            principal: that.editForm.principal,
                            create_time: that.editForm.createAt,
                            remark: that.editForm.remark,
                            order_detail: that.editForm.order_detail,
                        }
                    }).then(res => {
                            that.load = false
                            if (res.data.code == 200) {
                                that.$Message.success("编辑成功")
                                that.showTable()
                                that.editForm = {
                                    supplier_name: "", order_code: "", status: "1", principal: "", create_time: "", remark: "",
                                    order_detail: [
                                        { name: "", sku: "", count: "1", price: "", remark: "" },
                                    ]
                                }
                                that.valifate2 = false
                                that.showEdit = false
                            } else {
                                that.$Message.warning(res.data.data.msg)
                            }
                        }).catch(e => {
                            console.log(e)  
                            that.load = false
                            that.$Message.error("網絡錯誤, 請稍後再試")
                        })
                }
                
            })
        },
        edit (item) {
            this.showEdit = true
            item.status=String(item.status)
            this.editForm = item
        },
        del (item) {
            let that = this
            that.$Modal.confirm({
                title: '提示',
                content : "確定刪除這條信息?",
                onOk () {
                    that.$axios({
                        url: "admin/supplierOrder",
                        method:"DELETE",
                        data: {
                            uuid: item.uuid,
                            order_code: item.order_code
                        }
                    }).then(res => {
                        that.$Message.success('已刪除')
                        that.showTable()
                    })
                }
            })
        },

        // 初始化創建時間和隨機訂單編號
        initaddFormData () {
            let now = new Date()
            let ex = new Date( Date.now() + 611800000 )

            let y1 = now.getFullYear()
            let m1 = now.getMonth() + 1
            m1 = m1 < 10 ? '0' + m1 : m1
            let d1 = now.getDate()
            d1 = d1 < 10 ? '0' + d1 : d1
            this.addForm.create_time = y1 + "-" + m1 + "-" + d1

            
            let order_code = ''
            for (var i = 0; i < 6; i++) {
                order_code += Math.floor(Math.random() * 10);
            }
            order_code = 'D' + new Date().getTime() + order_code
            this.addForm.order_code = order_code
        },

    }
}
</script>

